<template>
  <PointNotificationPanelSmall
    :url="url"
    class="p-the-a01-point-notification-panel-thanksOnlyPoint"
    :class="`-${currentIcon.color}`"
  >
    <template #icon>
    <component :is="currentIcon.icon" />
    </template>
    <template #title>{{ thanksOnlyPointName }}が<br />付与されました！</template>
    <template #detail>
      <div class="p-the-a01-point-notification-panel-thanksOnlyPoint__detail">
        <p class="p-the-a01-point-notification-panel-thanksOnlyPoint__detail__text">
          <!-- ポイント数： -->
          <span class="u-text-weight--bold" data-translate-skip
            >{{ addComma(point) }} {{ unit.point }}</span
          >
        </p>
      </div>
    </template>
  </PointNotificationPanelSmall>
</template>

<script lang="ts">
import PointNotificationPanelSmall from "@/general/components/molecules/PointNotificationPanelSmall.vue";
import IconNotificationInvestedBlue from "@/common/components/icons/IconNotificationInvestedBlue.vue";
import IconNotificationInvestedGreen from "@/common/components/icons/IconNotificationInvestedGreen.vue";
import IconNotificationInvestedRed from "@/common/components/icons/IconNotificationInvestedRed.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";
import { getThanksOnlyPointName } from "@/common/assets/js/utils/pointName";

@Options({
  props: {
    point: { type: Number, required: true },
    url: { type: String, required: true }
  },
  components: {
    PointNotificationPanelSmall,
    IconNotificationInvestedBlue,
    IconNotificationInvestedGreen,
    IconNotificationInvestedRed
  }
})
export default class A01PointNotificationPanelThanksOnlyPoint extends Vue {
  title!: string;
  investedReason!: string;
  point!: number;
  url!: string;

  icons = [
    { icon: "IconNotificationInvestedBlue", color: "orange" },
    { icon: "IconNotificationInvestedGreen", color: "orange" },
    { icon: "IconNotificationInvestedRed", color: "orange" }
  ];
  currentIcon = this.icons[0];
  unit = commons.unit;

  created() {
    this.currentIcon = this.random(this.icons);
  }

  get notificationIcon() {
    return this.currentIcon;
  }
  
  get thanksOnlyPointName() {
    return getThanksOnlyPointName(CONST_DATA.POINT_NAME.THANKS_ONLY_POINT_DEFAULT_NAME1);
  }

  random<T>(array: T[]): T {
    return array[Math.floor(Math.random() * array.length)];
  }

  addComma(value: any) {
    const number = Number(value);
    if (Number.isNaN(number)) return value;
    return number.toLocaleString();
  }
}
</script>

<style lang="scss" scoped>
.p-the-a01-point-notification-panel-thanksOnlyPoint {
  &.-orange {
    background-color: #FFC66B;
  }

  &__detail__text {
    @include text__body--xs;
    color: $common-white;
  }
}
</style>
